import { TextField, styled } from 'shared/Houston';

export const DescriptionField = styled(TextField)`
  margin-top: ${({ theme }) => theme.spacing.nano};
`;
